import { render, staticRenderFns } from "./UnassignedReservations.vue?vue&type=template&id=51857a39&scoped=true"
import script from "./UnassignedReservations.vue?vue&type=script&lang=js"
export * from "./UnassignedReservations.vue?vue&type=script&lang=js"
import style0 from "./UnassignedReservations.vue?vue&type=style&index=0&id=51857a39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51857a39",
  null
  
)

export default component.exports